import Container from '@/components/Container';
import useRegister from './useRegister';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import Button from '@/components/Button';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import DialogTermsAndServices from '@/components/DialogTermsAndServices';
import FieldError from '@/components/FieldError';
import SubContainer from '@/components/Container/SubContainer';
import Loading from '../login/loading.skeleton';

const RegistrationForm = () => {
  const { formRef, handleSubmit, registerPage, register, errors, isLoading } = useRegister();
  const [open, setOpen] = useState<boolean | null>(null);

  if (!registerPage) return <Loading />;

  return (
    <Container>
      <SubContainer className="flex min-h-[100vh] items-center justify-center">
        <div className="max-h-[90vh] max-w-[500px] grow overflow-auto rounded-2xl bg-white p-8 shadow-light-purple">
          <div className=" flex flex-col items-center justify-center">
            <h1 className="mb-4 font-cadiz text-sh-md font-bold">{registerPage?.welcomeToTItle}</h1>
            <img
              className="mb-sh-15 w-[265px] "
              src={registerPage?.pageImage.data?.attributes?.url}
              alt={registerPage?.pageImage.data?.attributes?.alternativeText || 'Logo'}
            />
          </div>
          <div className="mt-sh-60 ">
            <h2 className="mb-sh-15 font-cadiz text-sh-28-32 font-bold">{registerPage?.registerTitle}</h2>
            <form ref={formRef} onSubmit={handleSubmit} className="flex flex-col gap-2">
              <div>
                <Label>
                  <p className="mb-2 font-cadiz text-sh-xs">{registerPage?.schoolCode}</p>
                </Label>
                <Input placeholder={registerPage?.schoolCode} type="schoolCode" {...register('schoolCode')} />
                <FieldError message={errors?.schoolCode?.message} />
              </div>

              <div>
                <Label>
                  <p className="mb-2 font-cadiz text-sh-xs">{registerPage?.yourFirstName}</p>
                </Label>
                <Input placeholder={registerPage?.yourFirstName} {...register('forename')} />
                <FieldError message={errors?.forename?.message} />
              </div>
              <div>
                <Label>
                  <p className="mb-2 font-cadiz text-sh-xs">{registerPage?.yourLastName}</p>
                </Label>
                <Input placeholder={registerPage?.yourLastName} {...register('surname')} />
                <FieldError message={errors?.surname?.message} />
              </div>

              <div className="w-full">
                <Label>
                  <p className="mb-2 font-cadiz text-sh-xs">{registerPage?.yourEmail}</p>
                </Label>
                <Input placeholder={registerPage?.yourEmail} type="email" {...register('email')} />
                <FieldError message={errors?.email?.message} />
              </div>

              <div>
                <Label>
                  <p className="mb-2 font-cadiz text-sh-xs">{registerPage?.choosePassword}</p>
                </Label>
                <Input placeholder={registerPage?.choosePassword} type="password" {...register('password')} />
                <FieldError message={errors?.password?.message} />
              </div>
              <div>
                <Label>
                  <p className="mb-2 font-cadiz text-sh-xs">{registerPage?.repeatYourPassword}</p>
                </Label>
                <Input
                  placeholder={registerPage?.repeatYourPassword}
                  type="password"
                  {...register('confirmPassword')}
                />
                <FieldError message={errors?.confirmPassword?.message} />
              </div>

              <div className="w-full">
                <Label className="mb-2 flex items-center">
                  <input type="checkbox" {...register('termsAndConditions')} />
                  <p className="ml-2 text-sh-xs">
                    I agree to the{' '}
                    <button
                      type="button"
                      onClick={() => {
                        setOpen(true);
                      }}
                      className="font-bold underline hover:text-primary-600">
                      terms and conditions
                    </button>
                  </p>
                </Label>
                <FieldError message={errors?.termsAndConditions?.message} />
              </div>

              <div className="mb-5 w-full">
                <Label className="flex items-center">
                  <p className="text-sh-xs">
                    Already registered?{' '}
                    <Link to="/login" className="font-bold underline hover:text-primary-600">
                      Sign in
                    </Link>
                  </p>
                </Label>
              </div>

              <Button type="submit" theme="solid" className="mb-4 self-start" loading={isLoading}>
                {registerPage?.createYourAccountCta}
              </Button>
            </form>
          </div>
        </div>
      </SubContainer>
      <DialogTermsAndServices open={open || false} setOpen={setOpen} />
    </Container>
  );
};

export default RegistrationForm;
